import React from "react"
import { withStyles } from "@material-ui/core/styles"
import {} from "assets/jss/material-dashboard-react.js"
import { connect } from "react-redux"
import Actions from "redux/actions"
import api from "axios.js"
import Button from "components/CustomButtons/Button.js"
import { withRouter } from "react-router"
import MaterialTable from "components/MaterialTable.js"
import PubSub from "pubsub-js"
import { appartementListColumns } from "utils/columns"
import axios from "axios"

class AppartementsList extends React.Component {
  constructor(props) {
    super(props)
    this.state = { tableLoading: false }
    this.actionsCache = null
    this.actionsCacheKey = null
    this.cancelSources = new Set()
    this._isMounted = false
    this.filteredCache = null
    this.filteredCacheKey = null
    this.filteredCacheToggle = null
    this.tableRef = React.createRef()
  }

  componentDidMount() {
    this._isMounted = true
  }

  componentWillUnmount() {
    this._isMounted = false
    this.cancelAllRequests("AppartementsList unmounted")
    this.actionsCache = null
    this.actionsCacheKey = null
    this.filteredCache = null
    this.filteredCacheKey = null
  }

  updateState = (updater, cb) => {
    if (this._isMounted) {
      this.setState(updater, cb)
    }
  };

  createCancelSource = () => {
    const source = axios.CancelToken.source()
    this.cancelSources.add(source)
    return source
  }

  releaseCancelSource = (source) => {
    if (source && this.cancelSources.has(source)) {
      this.cancelSources.delete(source)
    }
  }

  cancelAllRequests = (reason = "cancel") => {
    this.cancelSources.forEach((source) => {
      try {
        source.cancel(reason)
      } catch (_) {}
    })
    this.cancelSources.clear()
  }

  trackPromise = (promise, source) => {
    if (promise && typeof promise.finally === "function") {
      promise.finally(() => this.releaseCancelSource(source))
    } else {
      this.releaseCancelSource(source)
    }
    return promise
  }

  getActions = () => {
    if (this.actionsCache && this.actionsCacheKey === this.props.canDelete) {
      return this.actionsCache
    }
    const { canDelete } = this.props
    const actions = [
      {
        icon: "edit",
        tooltip: "Modifier l'appartement",
        onClick: (event, rowData) => this.props.history.push(`/appartements/${rowData.id}/edit`),
      },
      {
        icon: "remove_red_eye",
        tooltip: "Voir les details de l'appartement",
        onClick: (event, rowData) => this.props.history.push(`/appartements/${rowData.id}`),
      },
      canDelete && {
        icon: "delete",
        tooltip: "Supprimer l'appartement",
        onClick: (event, rowData) =>
          PubSub.confirm({
            title: "Supprimer l'element ?",
            subtitle: "Cette action est irreversible.",
            onAgree: _ => this.props.dispatch(Actions.deleteAppartement(rowData.id)),
          }),
      },
      {
        icon: p => <Button color='primary'>Nouvel Appartement</Button>,
        isFreeAction: true,
        onClick: event => this.props.history.push(`/appartements/new`),
      },
    ].filter(Boolean)
    this.actionsCache = actions
    this.actionsCacheKey = canDelete
    return this.actionsCache
  }

  fetchAppartements = (query = {}) => {
    const requestedPage = query.page || 0
    const requestedPageSize = query.pageSize || 20
    const search = query.search?.trim()
    const orderBy = query.orderBy?.field
    const orderDirection = query.orderDirection
    const filters =
      Array.isArray(query.filters) && query.filters.length
        ? query.filters
            .filter((f) => f?.value)
            .map((f) => ({ field: f?.column?.field, value: f.value }))
        : undefined

    const source = this.createCancelSource()
    this.updateState({ tableLoading: true, pageSize: requestedPageSize })

    const params = {
      page: requestedPage + 1,
      pageSize: requestedPageSize,
      search: search || undefined,
      orderBy: orderBy || undefined,
      orderDirection: orderDirection || undefined,
      filters: filters ? JSON.stringify(filters) : undefined,
    }

    return api
      .get("/Appartement/listLite", { params, cancelToken: source.token })
      .then(({ data }) => {
        const raw = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : []
        const payload = raw.map((a) => ({
          ...a,
          proprietaires: a.proprietaires
            ? a.proprietaires
            : a.proprietaire
            ? [a.proprietaire]
            : [],
          locataires: Array.isArray(a.locataires) ? a.locataires : [],
        }))
        const totalCount =
          typeof data?.total === "number"
            ? data.total
            : typeof data?.totalCount === "number"
            ? data.totalCount
            : payload.length
        this.updateState({ tableLoading: false })
        return { data: payload, page: requestedPage, totalCount }
      })
      .catch((error) => {
        if (axios.isCancel(error)) return { data: [], page: requestedPage, totalCount: 0 }
        this.updateState({ tableLoading: false })
        PubSub.notif({
          txt: "Impossible de charger les appartements.",
          color: "danger",
        })
        return { data: [], page: requestedPage, totalCount: 0 }
      })
      .finally(() => this.releaseCancelSource(source))
  }

  render() {
    const c = this.props.classes
    const { tableLoading } = this.state
    return (
      <div className={c.container}>
        <MaterialTable
          title=''
          isLoading={tableLoading}
          data={this.fetchAppartements}
          columns={appartementListColumns}
          actions={this.getActions()}
          onRowClick={(event, rowData) => this.props.history.push(`/appartements/${rowData.id}`)}
          options={{
            filtering: true,
            pageSize: 20,
            actionsColumnIndex: -1,
          }}
          tableRef={this.tableRef}
        />
      </div>
    )
  }
}

const styles = theme => ({
  container: {},
})

const mapStateToProps = state => ({
  appartements: state.reducer.appartements,
  canDelete: state.reducer.canDelete,
})
export default withRouter(withStyles(styles)(connect(mapStateToProps)(AppartementsList)))
